import { ViewExplanation } from '@doltech/modules/lib/view-explanation/ViewExplanation';
import { withDolPremiumStore } from '@doltech/ui/lib/hooks/dolPremium/withDolPremium';
import { compose } from '@doltech/utils/lib/compose';
import * as React from 'react';
import styled from 'styled-components';

const Main = styled.div`
  height: 100%;
  background: #fafafa;
`;

const ViewSolutionTemplatePage = (props) => {
  const { data, ...rest } = props;
  const testData = {
    ...data,
    testSection: { ...data },
    test: { ...data },
  };

  if (!data) return <div>Empty Data</div>;
  return (
    <Main>
      <ViewExplanation data={testData} {...rest} />
    </Main>
  );
};

export default compose(
  withDolPremiumStore({
    onDismissExpiredModal: ({ props, historyRouter, router }) => {},
  })
)(ViewSolutionTemplatePage);
